"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useNeumorphicTheme } from "@/hooks/useNeumorphicTheme";
interface MouseFollowTooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  className?: string;
}
export function MouseFollowTooltip(t0) {
  const $ = _c(17);
  const {
    children,
    content,
    className
  } = t0;
  const [isHovered, setIsHovered] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      x: 0,
      y: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [pos, setPos] = useState(t1);
  const [mounted, setMounted] = useState(false);
  const isNeumorphic = useNeumorphicTheme();
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const timer = setTimeout(() => setMounted(true), 0);
      return () => clearTimeout(timer);
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e => {
      setPos({
        x: e.clientX,
        y: e.clientY
      });
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleMouseMove = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e_0 => {
      setPos({
        x: e_0.clientX,
        y: e_0.clientY
      });
      setIsHovered(true);
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleMouseEnter = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setIsHovered(false);
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const handleMouseLeave = t6;
  const t7 = isHovered ? "true" : undefined;
  const t8 = className || "inline-flex items-stretch relative";
  let t9;
  if ($[6] !== content || $[7] !== isHovered || $[8] !== isNeumorphic || $[9] !== mounted || $[10] !== pos) {
    t9 = mounted && isHovered && createPortal(<div style={{
      position: "fixed",
      left: `${pos.x + 14}px`,
      top: `${pos.y + 18}px`,
      pointerEvents: "none",
      zIndex: 99999
    }} className={`px-3 py-1.5 text-xs font-black uppercase tracking-wider whitespace-nowrap pointer-events-none transition-opacity duration-75 ${isNeumorphic ? "bg-[#e0e5ec] text-[#1e293b] border-2 border-black rounded-xl shadow-[4px_4px_8px_rgba(163,177,198,0.6)]" : "bg-black text-white border-2 border-white shadow-[4px_4px_0px_rgba(255,255,255,0.4)]"}`}>{content}</div>, document.body);
    $[6] = content;
    $[7] = isHovered;
    $[8] = isNeumorphic;
    $[9] = mounted;
    $[10] = pos;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== children || $[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
    t10 = <div data-has-tooltip="true" data-tooltip-active={t7} className={t8} onMouseEnter={handleMouseEnter} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave}>{children}{t9}</div>;
    $[12] = children;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}